import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import {
    STUDENT_INFO_STUDENT,
    STUDENT_INFO_BY_STUDENT_NUMBER,
    STUDENT_INFO_BASIC_BY_STUDENT_NUMBER,
    STUDENTS_BY_GUARDIAN_GET
} from "../const/StudentInfoConst";

/**
 * Data Access for the student-info-sb API
 * @name StudentInfoDao
 * @param {{}} props
 * @return {null|*}
 */
const StudentInfoDao = (props) => {
    const { action, params, schoolYearKey, studentNumber, token, username } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        }
    };
    switch (action) {
        case "studentImageRead":
            options.method = "GET";
            options.responseType = "blob";
            options.url = `${STUDENT_INFO_STUDENT}/${studentNumber}/${schoolYearKey}/image`;
            break;
        case "studentInfoByNumberGet":
            options.method = "GET";
            options.url = `${STUDENT_INFO_BY_STUDENT_NUMBER}/${studentNumber}/detail.json`;
            break;
        case "studentInfoBasicByNumberGet":
            options.method = "GET";
            options.url = `${STUDENT_INFO_BASIC_BY_STUDENT_NUMBER}/${studentNumber}/detail.json`;
            break;
        case "studentsByGuardianRead":
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.url = `${STUDENTS_BY_GUARDIAN_GET}/${username}/index.json`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

StudentInfoDao.propTypes = {
    action: PropTypes.string.isRequired,
    params: PropTypes.oneOfType([PropTypes.object]),
    schoolYearKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    studentNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    token: PropTypes.string.isRequired,
    username: PropTypes.string
};

StudentInfoDao.defaultProps = {
    params: null,
    schoolYearKey: null,
    studentNumber: null,
    username: null
};

export default StudentInfoDao;
